import { language as hint_language } from "./hint";
import { language as content_language } from "./content";
import { language as defaultShipping_language } from "./setting-default-shipping/index";

let language = {
    ...hint_language,
    ...content_language,
    ...defaultShipping_language,
};

export { language }